<div>
    <span class="counter" [ngStyle]="{'font-size': this.fontSize}">
        <span>0{{ this.counterMin }}</span>
        :
        <span *ngIf="this.counterSec >= 10">{{ this.counterSec }}</span>
        <span *ngIf="this.counterSec < 10">0{{ this.counterSec }}</span>
    </span>
</div>
